"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Collapsible = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _jsxRuntime = require("react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

var _react2 = require("@fluentui/react");

var _useTheme = require("../hooks/useTheme");

var _CollapsibleContent = require("./CollapsibleContent");

var _CollapsibleHeader = require("./CollapsibleHeader");

var _CollapsibleToggle = require("./CollapsibleToggle");

var getClassNames = (0, _react2.classNamesFunction)();
/**
 * A card with header and content sections. The header is always visible.
 * Content can be hidden/shown by clicking on a caret button in the header.
 *
 * Any `TitleBarLabel` or `TitleBarAction` _immediate_ children will be pulled
 * into the header. All other children will be placed in the hideable content
 * section.
 */

var CollapsibleBase = function CollapsibleBase(_ref) {
  var className = _ref.className,
      _ref$expanded = _ref.expanded,
      expanded = _ref$expanded === void 0 ? false : _ref$expanded,
      iconProps = _ref.iconProps,
      headerResponsiveMode = _ref.headerResponsiveMode,
      _ref$toggle = _ref.toggle,
      toggle = _ref$toggle === void 0 ? _CollapsibleToggle.CollapsibleToggle.caret : _ref$toggle,
      onCollapse = _ref.onCollapse,
      onExpand = _ref.onExpand,
      onRenderHeader = _ref.onRenderHeader,
      onRenderContent = _ref.onRenderContent,
      styles = _ref.styles,
      ariaLabel = _ref.ariaLabel;
  var theme = (0, _useTheme.useTheme)();

  var _useState = (0, React.useState)(expanded),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isExpanded = _useState2[0],
      setExpanded = _useState2[1];

  var _getClassNames = getClassNames(styles, {
    theme: theme,
    isExpanded: isExpanded
  }),
      subComponentStyles = _getClassNames.subComponentStyles,
      classes = (0, _objectWithoutProperties2.default)(_getClassNames, ["subComponentStyles"]);

  var onClick = (0, React.useCallback)(function (event) {
    if (event.isDefaultPrevented()) {
      return;
    }

    var nextExpanded = !isExpanded;
    setExpanded(nextExpanded);

    if (nextExpanded) {
      onExpand && onExpand();
    } else {
      onCollapse && onCollapse();
    }
  }, [onExpand, onCollapse, isExpanded]);
  (0, React.useEffect)(function () {
    return setExpanded(expanded);
  }, [expanded]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _react2.css)('ms-Collapsible', className, classes.root),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CollapsibleHeader.CollapsibleHeader, {
      ariaLabel: ariaLabel,
      iconProps: iconProps,
      isExpanded: isExpanded,
      toggle: toggle,
      onClick: onClick,
      responsiveMode: headerResponsiveMode,
      styles: subComponentStyles.header,
      children: onRenderHeader()
    }), isExpanded && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CollapsibleContent.CollapsibleContent, {
      styles: subComponentStyles.content,
      children: onRenderContent()
    })]
  });
};

var Collapsible = (0, _react2.styled)(CollapsibleBase, function (_ref2) {
  var palette = _ref2.theme.palette,
      isExpanded = _ref2.isExpanded;
  return {
    root: [{
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'semanticColors.bodyBackground'
    }, isExpanded && {
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: palette.neutralTertiary
    }]
  };
});
exports.Collapsible = Collapsible;